module.exports = __webpack_public_path__ + "static/lovelo-line-light-349b19552f350020bec8682a4b6787b5.ttf";